var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group row select-intervenant" }, [
    _vm.isLabelVisible()
      ? _c("label", { staticClass: "col-12 col-form-label text-left" }, [
          _vm._v(_vm._s(_vm.label))
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "col-12" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.serializedValue,
            expression: "serializedValue"
          }
        ],
        attrs: {
          type: "hidden",
          name: _vm.name,
          "data-serialized": "true",
          required: _vm.required
        },
        domProps: { value: _vm.serializedValue },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.serializedValue = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      !_vm.readonly
        ? _c(
            "div",
            { staticClass: "input-group flex-nowrap" },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedRole,
                      expression: "selectedRole"
                    }
                  ],
                  staticClass:
                    "input-group-prepend custom-select role-select-new",
                  attrs: { disabled: _vm.readonly },
                  on: {
                    click: function($event) {
                      return _vm.loadAvailableRoles()
                    },
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectedRole = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c(
                    "option",
                    { attrs: { disabled: "", selected: "", value: "" } },
                    [_vm._v(" – Rôle à affecter ")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.availableRoles, function(role) {
                    return _c("option", { domProps: { value: role.name } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(role.view) +
                          "\n                "
                      )
                    ])
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "v-select",
                {
                  ref: "select",
                  staticClass: "form-control p-0",
                  attrs: {
                    "on-search": _vm.getOptions,
                    "on-change": _vm.onChange,
                    options: _vm.options,
                    placeholder: _vm.noValueLabel,
                    "get-option-label": _vm.getLabel,
                    disabled: _vm.selectedRole == "" || _vm.readonly,
                    label: "email"
                  }
                },
                [
                  _c(
                    "span",
                    { attrs: { slot: "no-options" }, slot: "no-options" },
                    [
                      _vm._v(
                        "\n                    Aucun résultat\n                    "
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: { type: "button" },
                          on: { focus: _vm.toggleOther }
                        },
                        [_vm._v("Autre")]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: " input-group-append" }, [
                !_vm.readonly
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        attrs: {
                          type: "button",
                          disabled: _vm.selectedRole == ""
                        },
                        on: { click: _vm.toggleOther }
                      },
                      [_vm._v("Autre")]
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.other
        ? _c("div", { staticClass: "input-group mt-1" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.otherIntervenant.firstName,
                  expression: "otherIntervenant.firstName"
                },
                { name: "focus", rawName: "v-focus" }
              ],
              staticClass: "form-control",
              attrs: { type: "text", placeholder: "Nom" },
              domProps: { value: _vm.otherIntervenant.firstName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.otherIntervenant,
                    "firstName",
                    $event.target.value
                  )
                }
              }
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.otherIntervenant.lastName,
                  expression: "otherIntervenant.lastName"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", placeholder: "Prénom" },
              domProps: { value: _vm.otherIntervenant.lastName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.otherIntervenant,
                    "lastName",
                    $event.target.value
                  )
                }
              }
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.otherIntervenant.email,
                  expression: "otherIntervenant.email"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "email", placeholder: "Email" },
              domProps: { value: _vm.otherIntervenant.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.otherIntervenant, "email", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-group-append" }, [
              !_vm.readonly
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.addOther()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-plus" })]
                  )
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.readonly && _vm.selected.length == 0
        ? _c("em", [_vm._v("Aucun intervenant")])
        : _vm._e(),
      _vm._v(" "),
      _vm.selected.length > 0
        ? _c(
            "ul",
            { staticClass: "list-group mt-1" },
            _vm._l(_vm.selected, function(item) {
              return _c(
                "li",
                {
                  staticClass:
                    "list-group-item list-group-item-light d-flex justify-content-between align-items-center p-0 pr-2",
                  staticStyle: { overflow: "hidden" }
                },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: item.role,
                          expression: "item.role"
                        }
                      ],
                      staticClass:
                        "custom-select custom-select-sm role-select-edit",
                      on: {
                        click: function($event) {
                          return _vm.loadAvailableRoles()
                        },
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              item,
                              "role",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          _vm.updateData
                        ]
                      }
                    },
                    _vm._l(_vm.availableRoles, function(role) {
                      return _c("option", { domProps: { value: role.name } }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(role.view) +
                            "\n                    "
                        )
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-2 mr-auto" }, [
                    _vm._v(_vm._s(_vm.getLabel(item)))
                  ]),
                  _vm._v(" "),
                  _vm.candelete !== false && !_vm.readonly
                    ? _c(
                        "a",
                        {
                          staticClass: "badge badge-primary badge-pill",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              return _vm.deleteIntervenant(item)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-trash" })]
                      )
                    : _vm._e()
                ]
              )
            }),
            0
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("Autre :")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42468998", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42468998","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/SelectIntervenant.vue
// module id = 563
// module chunks = 0